export default __webpack_public_path__ + "images/max-messenger.4c079bfc1ae412d9ad6059901e332777.png";